(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const animate = (element, frames, options) => {
    if (!motion.matches && element?.animate) element.animate(frames, options);
  };
  class BuyerGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [...this.querySelectorAll('[data-buyer-choice]')];
      this.panels = [...this.querySelectorAll('[data-buyer-panel]')];
      if (this.buttons.length !== this.panels.length || !this.buttons.length) return;
      this.querySelector('[data-buyer-controls]').hidden = false;
      this.setAttribute('data-enhanced', '');
      this.select(this.buttons[0].dataset.buyerChoice, false);
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-buyer-choice]');
        if (button) this.select(button.dataset.buyerChoice, true);
      }, {signal: this.controller.signal});
      this.addEventListener('keydown', event => {
        const current = this.buttons.indexOf(event.target);
        if (current < 0 || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
        this.buttons[next].focus();
        this.select(this.buttons[next].dataset.buyerChoice, true);
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    select(key, moving) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.buyerChoice === key)));
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.buyerPanel !== key;
        if (!panel.hidden && moving) animate(panel,[{opacity:.5,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'cubic-bezier(.16,1,.3,1)'});
      });
    }
  }
  class OrderJourney extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.stages = [...this.querySelectorAll('[data-stage]')];
      this.photos = [...this.querySelectorAll('[data-stage-photo]')];
      this.photoHome = this.querySelector('.vxw-journey__images');
      this.mobile = matchMedia('(max-width: 649px)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile.addEventListener('change', () => this.update(this.stages.find(stage => stage.open) || this.stages[0], false), {signal});
      this.querySelectorAll('[data-stage-next]').forEach(button => button.hidden = false);
      this.stages.forEach(stage => stage.addEventListener('toggle', () => {
        if (!stage.open) return;
        this.stages.forEach(other => { if (other !== stage) other.open = false; });
        this.update(stage);
      }, {signal}));
      this.addEventListener('click', event => {
        const next = event.target.closest('[data-stage-next]');
        if (!next) return;
        const current = next.closest('[data-stage]');
        const target = this.stages[this.stages.indexOf(current) + 1];
        if (!target) return;
        current.open = false;
        target.open = true;
        this.update(target);
        target.querySelector('summary').focus({preventScroll:true});
        target.scrollIntoView({block:'start',behavior:motion.matches ? 'instant':'smooth'});
      }, {signal});
      this.update(this.stages.find(stage => stage.open) || this.stages[0], false);
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    update(stage, moving = true) {
      if (!stage) return;
      this.stages.forEach(item => {
        const summary = item.querySelector('summary');
        if (item === stage) summary.setAttribute('aria-current','step');
        else summary.removeAttribute('aria-current');
      });
      this.style.setProperty('--journey-progress', `${(this.stages.indexOf(stage) + 1) / this.stages.length * 100}%`);
      this.photos.forEach(photo => {
        const selected = photo.dataset.stagePhoto === stage.dataset.stage;
        const changed = photo.hidden && selected;
        photo.hidden = !selected;
        if (selected && this.mobile.matches) stage.querySelector('.vxw-stage__body').prepend(photo);
        else if (photo.parentElement !== this.photoHome) this.photoHome.append(photo);
        if (changed && moving) animate(photo,[{opacity:.4,clipPath:'inset(0 0 8% 0)',transform:'translateY(12px)'},{opacity:1,clipPath:'inset(0 0 0 0)',transform:'translateY(0)'}],{duration:520,easing:'cubic-bezier(.16,1,.3,1)'});
      });
    }
  }
  if (!customElements.get('vxw-buyer-guide')) customElements.define('vxw-buyer-guide',BuyerGuide);
  if (!customElements.get('vxw-order-journey')) customElements.define('vxw-order-journey',OrderJourney);
  const bindContext = () => {
    document.querySelectorAll('[data-wholesale-context]').forEach(link => {
      link.setAttribute('data-b2b-choice','');
      link.dataset.context = link.dataset.wholesaleContext;
      link.dataset.request = link.dataset.wholesaleRequest || 'quote';
      link.dataset.pack = link.dataset.wholesalePack || 'unchanged';
    });
    const feedback = document.querySelector('[data-b2b-success], [data-b2b-errors]');
    if (feedback) feedback.focus();
  };
  bindContext();
  document.addEventListener('shopify:section:load',bindContext);
  document.addEventListener('shopify:block:select', event => {
    const stage = event.target.closest('[data-stage]');
    if (stage) stage.open = true;
    const panel = event.target.closest('[data-buyer-panel]');
    if (panel) panel.closest('vxw-buyer-guide')?.select(panel.dataset.buyerPanel, false);
  });
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelectorAll('.vxw').forEach(root => root.getAnimations({subtree:true}).forEach(animation => animation.cancel()));
  });
})();
